import React from 'react';
import { Modal } from 'antd';
import SupportChatModuleTagsTable from './SupportChatModuleTagsTable';

const ManageTagsModal = ({ visible, onCancel }) => (
  <Modal
    title="Manage Tags"
    visible={visible}
    onCancel={onCancel}
    footer={null}
    width="100%"
    style={{ top: 0, paddingBottom: 0 }}
    bodyStyle={{ height: 'calc(100vh - 55px)' }}
    destroyOnClose
  >
    <SupportChatModuleTagsTable />
  </Modal>
);

export default ManageTagsModal;
